import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { NoPermissionPage } from "@/pages/NoPermissionPage";
import { hasAnyPermission } from "./permissions";
import { requiredPermsFor } from "./routePermissions";

/** RBAC-ENF1 · 包在页面出口外：当前路径需要的权限点用户没有 → 显示「没有权限访问这个页面」。 */
export function RoutePermissionGate({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const perms = useAuthStore((s) => s.user?.permissions);
  const need = requiredPermsFor(pathname);
  if (need && !hasAnyPermission(perms, need)) return <NoPermissionPage needed={need} />;
  return <>{children}</>;
}
